import React from "react"

import PopupMenuButton from "../../popup-menu-button/popup-menu-button"
import PopoverMenuOptionButton from "./option-button"
import PopoverMenuOptionSubmenu from "./option-submenu"

type Props = {
    className?          : string
    menuClassName?      : string
    highlightClass?     : string
    id?                 : ID
    option              : Option
    isHighlighted?      : boolean
    showMenuSelection?  : boolean
    selectedValue?      : any

    disabled?           : boolean

    onClick?            : callback
    onTogglePopover?    : func
    hidePopover?        : func
}

export default function PopoverMenuOptionWithSubmenu(props: Props) {
    const disabled : boolean  = props.disabled || !!props.option.disabled

    return <PopupMenuButton
        className                   = {props.className}
        domElementId                = {props.id}
        popoverClass                = "popover-submenu min-w-250"
        attachment                  = "top left"
        targetAttachment            = "top right"
        offset                      = "0 0"
        attachmentType              = "vertical"
        arrowsVersion               = {2}
        btnComponent                = {PopoverMenuOptionButton}
        outsideClickIgnoreClasses   = {["popover-submenu"]}
        menuComponent               = {PopoverMenuOptionSubmenu}
        menuParams                  = {{
            menuClassName       : props.menuClassName,
            showButtonSelection : false,
            showMenuSelection   : props.showMenuSelection,
            option              : props.option,
            selectedValue       : props.selectedValue,
            isHighlighted       : props.isHighlighted,
            highlightClass      : props.highlightClass,
            onClick             : props.onClick,
            hidePopover         : props.hidePopover
        }}
        disabled                    = {disabled}
        clickOutsideDelay           = {100}
        onTogglePopover             = {props.option.onTogglePopover || props.onTogglePopover}
    />
}
